import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, NavigationExtras } from '@angular/router';
import { NgIf, NgFor, NgStyle, NgClass, DecimalPipe, DatePipe } from '@angular/common';
import { CustomMycompanyComponent } from '../custom-mycompany/custom-mycompany.component';

@Component({
    selector: 'app-custom-inventory-content',
    templateUrl: './custom-inventory-content.component.html',
    styleUrls: ['./custom-inventory-content.component.scss'],
    host: {
        '(window:resize)': 'onResize($event)'
    },
    imports: [NgIf, NgFor, NgStyle, NgClass, CustomMycompanyComponent, DecimalPipe, DatePipe]
})
export class CustomInventoryContentComponent implements OnInit {
  productInfo = {headerColor: {'bgColor':true}, shortDescription: 'JIMF',name:'Yandi Fine Ore17'};
  port = {name:'Tangshan Caofeidian'};
  @Input() grid: boolean;
  @Input() list: boolean;
  @Input('Data') publishedData: any;
  noData: boolean = false;
  constructor(private router: Router) { }

  width: any;
  ngOnInit(): void { 
    this.width=window.innerWidth < 994? true: false;
    if(this.publishedData.length){
      this.noData = false;
    }else{
      this.noData = true;
    }
  }
  ngOnChanges() {
  }
  onResize(event) {
    if (event.target.innerWidth < 994){
      this.width = true;
    }else{
      this.width = false;
    }
  }
  gotoDeatils(data) {
    const navigationData: NavigationExtras = {
      state: {
        data: data
      }
    };
    localStorage.setItem("inventoryDetailsId", data);
    this.router.navigate(['/inventory/inventorydetailspages'], navigationData);
  }
}
